import "./index.css";
import MyCenter from "./components/myCenter";
import BottomBar from "../../components/bottomBar";
import { userApi } from "../../api/user-api";
import { useContext, useEffect, useState } from "react";
import { companyApi } from "../../api/company";
import { LoginMsgContext } from "../../router/router";
import { useTranslation } from "react-i18next";
import { getText } from "../../utils/util";
import { AcendexLayout } from "../../components/acendex/components/layout/AcendexLayout";

export default function My() {
  const [userInfo, setUserInfo] = useState({});
  const [companyData, setCompanyData] = useState({} as any);
  const [loginmsg, setloginmsg] = useContext(LoginMsgContext);
  const [pledgeStatus,setPledgeStatus] = useState(0);
  const { t: translate } = useTranslation();
  
  const loadUserInfoData = async () => {
    const data = await userApi.userInfo();
    if (data.ok) {
      setUserInfo(data.data);
    }
  };
  //初始化获取公司
  async function initCompany() {
    const res = await companyApi.domain();
    if (res.ok) {
      setCompanyData(res.data);
    }
  }
  useEffect(() => {
    initCompany();
    loadUserInfoData();
    setPledgeStatus(Number(localStorage.getItem("pledgeStatus")))
  }, []);
  return (
    <div className="w-full min-h-dvh bg-neutral-900 revert-style">
      <AcendexLayout
        theme="light"
        mobileTopBarTitle={translate(getText("个人中心"))}
        pcTopBarTitle={translate(getText("个人中心"))}
        bottomBarIndex={5}
      >
        <div className="container mx-auto bg-neutral-900">
          <div className="p-4">
            <div className="rounded-lg bg-neutral-800 shadow-md overflow-hidden">
              <MyCenter 
                userInfo={userInfo} 
                companyData={companyData} 
                loginmsg={loginmsg} 
                pledgeStatus={pledgeStatus}
              />
            </div>
          </div>
        </div>
        <div className="h-14"></div>
        {/* <BottomBar index={5} /> */}
      </AcendexLayout>
    </div>
  );
}
